import { Box, Drawer } from '@mui/material';

import useResponsive from '@app/hooks/use-responsive';

interface Props {
  openNav: boolean;
  onCloseNav: VoidFunction;
  children?: React.ReactNode;
  hideBackdrop?: boolean;
}

const SideDrawer = ({ openNav = true, onCloseNav, children, hideBackdrop }: Props) => {
  const isMobile = useResponsive('down', 'sm');
  return (
    <Drawer
      anchor="right"
      open={openNav}
      onClose={onCloseNav}
      variant={'temporary'}
      PaperProps={{
        sx: {
          zIndex: 0,
          width: isMobile ? '100%' : '500px',
          display: 'block',
        },
      }}
      BackdropProps={{
        style: { display: hideBackdrop ? 'none' : '' },
      }}
    >
      <Box sx={{ p: 2 }}>{children}</Box>
    </Drawer>
  );
};

export { SideDrawer };
